import React, {useState} from 'react';
import {FaBook, FaQuestion} from "react-icons/fa";
import {FaFlaskVial} from "react-icons/fa6";
import {IoStatsChart} from "react-icons/io5";
import {BsCardHeading} from "react-icons/bs";
import {RiLoopLeftFill} from "react-icons/ri";
import {Link} from "react-router-dom";

function getHeaderIcon(type) {
    const iconSize = 16;
    switch (type) {
        default:
        case "Kurs":
            return (<FaBook size={iconSize}/> )
        case "Quiz":
            return (<FaQuestion size={iconSize}/>)
        case "Labkurs":
            return (<FaFlaskVial size={iconSize}/>);
        case "Evaluering":
            return (<IoStatsChart size={iconSize}/>);
        case "Begrep":
            return (<BsCardHeading size={iconSize}/>);
        case "Abonnement":
            return (<RiLoopLeftFill size={iconSize}/>)

    }
}


export function Tabs({items, currentTab}) {

    const [activeItem, setActiveItem] = useState(currentTab);

    return (
        <nav className="nav d-flex flex-column" role={"list"}>
            {
                items.map((item, idx) => (
                    <Link to={item.url} className={"course-panel-item p-2 rounded my-2 " +(item.url.includes(currentTab) ? " active " : "") } role={"listitem"}>
                        <span className={"me-2"}>
                            {getHeaderIcon(item.text)}
                        </span>
                        <label>{item.text}</label>
                    </Link>
                ))
            }
        </nav>
    );

}